export default __webpack_public_path__ + "static/media/Available_on_the_App_Store_(black).ac75cebb.png";